function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

// lodash stringToPath
// https://github.com/lodash/lodash/blob/4.17.15/lodash.js#L6735

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
var cache = {};
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath = function stringToPath(string) {
  if (cache[string]) {
    return cache[string];
  }

  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
      result.push('');
    }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  cache[string] = result;
  return result;
};

var caches = new WeakMap();
/**
 * Helper function for getting the value for a path or a fallback array.
 *
 * @method
 * @param path {string|array}
 * @param theme {object} The theme namespace.
 * @param caching {bool} Pull the value from cache if it exists.
 * @return {object} The derived value and an array of all values.
 */

var getValues = function getValues(path, theme, caching) {
  var paths = path;

  if (typeof path === 'string') {
    paths = [path];
  } // Translate the array of paths to an array of values


  var value;
  var values = [];

  for (var i = 0; i < paths.length && theme; i += 1) {
    var p = paths[i];
    var currentValue = void 0; // Get the cache for this theme object if it exists, or initialize the cache

    var cache = caches.get(theme);

    if (cache) {
      if (caching) {
        currentValue = cache[p];
      }
    } else {
      cache = {};
      caches.set(theme, cache);
    }

    if (typeof currentValue === 'undefined') {
      // Traverse the path
      currentValue = theme;
      var properties = stringToPath(p);

      for (var j = 0; j < properties.length && typeof currentValue !== 'undefined'; j += 1) {
        var property = properties[j];
        currentValue = currentValue[property];
      }
    } // Set outer value to the first defined value


    if (typeof value === 'undefined') {
      value = currentValue;
    }

    if (caching) {
      cache[p] = currentValue;
    }

    values[i] = currentValue;
  }

  return {
    value: value,
    values: values
  };
};
/**
 * See README.md for full documentation.
 *
 * @method
 * @param path {string|array|object}
 * @param [options] {object}
 * @param [callback] {function}
 * @return {function}
 */


var index = (function (path, options, callback) {
  if (options === void 0) {
    options = {};
  }

  return function (props) {
    if (typeof options === 'function') {
      // eslint-disable-next-line no-param-reassign
      callback = options; // eslint-disable-next-line no-param-reassign

      options = {};
    }

    var theme = props.theme; // Check for global options

    var globalOptions = theme && theme.STYLED_TOKEN;

    if (globalOptions) {
      // eslint-disable-next-line no-param-reassign
      options = _objectSpread2({}, globalOptions, {}, options);
    } // Check for namespace


    var namespace = theme && theme.NAMESPACE;

    if (typeof options.namespace === 'string') {
      // eslint-disable-next-line prefer-destructuring
      namespace = options.namespace;
    } // Move to namespace


    if (theme && namespace) {
      theme = theme[namespace];
    }

    var value;
    var values;

    if (typeof path === 'string' || Array.isArray(path)) {
      var results = getValues(path, theme, options.caching); // eslint-disable-next-line prefer-destructuring

      value = results.value; // eslint-disable-next-line prefer-destructuring

      values = results.values;
    } else if (_typeof(path) === 'object') {
      if (!callback) {
        throw new Error('`callback` is required when `path` is an `object`');
      }

      value = {};
      Object.keys(path).forEach(function (key) {
        var results = getValues(path[key], theme, options.caching);

        if (typeof results.value === 'undefined') {
          value[key] = options.defaultValue;
        } else {
          value[key] = results.value;
        }
      });
    } else {
      throw new Error('`path` should be one of `string`, `array`, `object`');
    } // defaultValue fallback


    if (typeof value === 'undefined') {
      value = options.defaultValue;
    }

    if (callback) {
      // Arrays gets both the derived value and the list of values as arguments
      if (Array.isArray(path)) {
        return callback(value, values);
      }

      return callback(value);
    }

    return value;
  };
});

export default index;
